import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, catchError, map, throwError } from 'rxjs';
import { FormData } from 'src/app/interfaces/form-data';
import { IncidentsService } from 'src/app/services/incidents.service';
import { SnackAlertService } from 'src/app/services/snack-alert.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent {
  uploadProgress: number | undefined; // Variabile per monitorare l'avanzamento del caricamento del file
  formData: { formData: any; valid: boolean } | undefined;
  waitingLoadFile: boolean = false;
  formData$: Observable<FormData> = this.service.getFormIncident().pipe(
    catchError((error: HttpErrorResponse) => {
      return throwError(() => {
        console.error(error);
        this.alertService.openSnackBar(
          error.error.error.message || error.message,
          'error-snackbar',
          3000,
          'Chiudi'
        );
        this.closeModal();
      });
    }),
    map((data: any) => {
      this.formData = {
        valid: false,
        formData: {
          fields: data.fields,
          elements: data.elements,
        },
      };
      this.spinnerService.close();
      return this.formData.formData;
    })
  );

  constructor(
    private readonly modalService: NgbModal,
    private readonly service: IncidentsService,
    private readonly activeModal: NgbActiveModal,
    private readonly spinnerService: SpinnerService,
    private readonly alertService: SnackAlertService
  ) {
    spinnerService.open();
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  handleFileInput(attachmentBase64: string) {
    this.formData?.formData.fields.forEach((field: any) => {
      if (field.name === 'incident_allegato') {
        field.value = attachmentBase64;
      }
    });
  }

  rmFileInput($event: any) {
    this.formData?.formData.fields.forEach((field: any) => {
      if (field.name === 'incident_allegato') {
        field.value = '';
      }
    });
  }

  submitForm() {
    if (!this.formData?.valid) {
      return;
    }
    this.activeModal.close({ form: this.formData.formData });
  }

  onEvent(event: any) {
    this.formData = event;
  }
}
